<div class="toolbar-wrapper" #toolbarWrapper>
  <div class="headerbar-title">
    <div class="title-group">
      <h1 class="title">{{ pageTitle || title() }}</h1>
      @if (backLink) {
        <a
          class="toolbar-back-link"
          [routerLink]="backLink"
          [attr.data-testid]="backLinkTestId || null"
        >
          &lt; {{ backLinkLabel || 'Back' }}
        </a>
      }
    </div>
    <div class="headerbar-actions">
      <button
        class="notification-btn"
        data-testid="notifications-bell-btn"
        [class.has-unread]="hasUnreadNotifications()"
        aria-label="Notificaciones"
        (click)="toggleNotifications($event)"
        [attr.aria-expanded]="notificationsOpen"
      >
        <span class="material-symbols-outlined notifications" aria-hidden="true">{{
          hasUnreadNotifications() ? 'notifications_unread' : 'notifications'
        }}</span>
      </button>
      <button
        class="account-btn"
        data-testid="account-btn"
        aria-label="Cuenta"
        (click)="toggleAccountPanel($event)"
        [attr.aria-expanded]="accountPanelOpen"
      >
        <span class="material-symbols-outlined account" aria-hidden="true">account_circle</span>
      </button>
    </div>
  </div>
  @if (!isHome() && showSelectedEntityName()) {
    <div class="states" data-testid="entity-status-bar">
      <span class="company-name">{{ selectedEntityName() }}</span>
      <div class="state-group" data-testid="entity-status-group">
        <app-status-split-dropdown
          [status]="selectedEntityStatus()"
          [subStatusOptions]="statusDescriptions"
          [loading]="selectedEntityStatusLoading()"
          [disabled]="!showStatusDropdown"
          (subStatusChange)="selectStatusDescription($event)"
        />
      </div>
    </div>
  }
</div>

@if (notificationsOpen) {
  <div
    #notificationsPanel
    class="notifications-panel-wrapper"
    data-testid="notifications-panel-wrapper"
    role="dialog"
    aria-label="Notifications"
  >
    <app-notifications-panel
      [notifications]="notifications()"
      [loading]="notificationsLoading"
      (reviewStatusChange)="onReviewStatusChange($event)"
      (notificationClick)="onNotificationClick($event)"
      (downloadDocument)="onDownloadDocument($event)"
    />
  </div>
}

<app-status-change-modal
  #statusChangeModal
  [isOpen]="showStatusChangeModal"
  [initialState]="statusChangeModalInitialState"
  [title]="statusChangeModalTitle"
  [processingResultTitle]="statusChangeModalProcessingTitle"
  [legalEntityName]="statusChangeModalData.legalEntityName"
  [currentStatus]="statusChangeModalData.currentStatus"
  [newStatus]="statusChangeModalData.newStatus"
  [alreadyProcessedBy]="statusChangeModalData.alreadyProcessedBy"
  (approve)="onApproveStatusChange()"
  (reject)="onRejectStatusChange()"
  (confirmChange)="onConfirmStatusChange()"
  (closed)="closeStatusChangeModal()"
/>

@if (accountPanelOpen) {
  <div
    class="account-panel"
    role="dialog"
    aria-label="User info"
    (click)="$event.stopPropagation()"
  >
    <div class="account-panel__inner">
      @if (userFullName(); as full) {
        <div class="user-initial">{{ full.charAt(0) }}</div>
      }
      <div class="user-name">{{ userFullName() }}</div>
    </div>
  </div>
}
